/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from "react";
import { OfflineIndicator } from "@/components/common/OfflineIndicator";
import { requestRecovery } from "@/lib/recovery";

// A stable reference, so the banner does not re-subscribe to the network
// service on every render.
function handleNetworkStatusChange(isOnline: boolean): void {
  if (isOnline) requestRecovery();
}

/**
 * A-2 / W-3 (S711 review): the app-wide offline banner, CONNECTED.
 *
 * It used to be rendered with a position and nothing else, so it announced
 * that the connection was back and nothing acted on it -- the cart stayed
 * blank and the checkout frame stayed dead under a message saying all was
 * well. Now the reconnection, and the Retry button, ask every mounted screen
 * to recover (lib/recovery.ts); each screen decides how.
 *
 * ST-2 (Session 752): fixed to the TOP edge. At the bottom it overlapped the
 * shop's pop-up messages (bottom-right, 356 pixels wide) in any window
 * narrower than about 1,270 pixels -- the desktop purchase window is 1,024 on
 * a 1,366-pixel laptop -- and covered the green button and Stripe's Pay
 * button, which sit at the bottom of an 800-pixel-high window. OfflineIndicator
 * keeps bottom as its own default; only this app-wide banner passes top.
 */
export const NetworkRecoveryBanner: React.FC = () => (
  <OfflineIndicator
    position="top"
    onStatusChange={handleNetworkStatusChange}
    onRetry={requestRecovery}
  />
);

export default NetworkRecoveryBanner;
